<template>
  <div class="articelInfo">
    <div class="basicInfo">
      <h3 class="title">{{ article.title }}</h3>
    </div>

    <div class="block">
      <el-timeline>
        <el-timeline-item v-for="item in processList" :key="item.processId" :timestamp="item.processTitle" placement="top"
          size="large" :type="setType(item.processStatus)">
          <template v-if="item.processStep == 10">
            <template v-if="role == 'EXPERT'">
              <p style="margin-bottom: 0">
                <img class="word" src="@/assets/word.png" /> {{ item.attachName }}
                <a @click="downArticle(item.fileId, item.attachName)" target="_blank" class="download">下载稿件原文</a>
              </p>
            </template>
            <template v-else>
              <el-descriptions border>
                <el-descriptions-item label="作者">{{
                  article.authorName
                }}</el-descriptions-item>
                <el-descriptions-item label="联系电话">{{
                  article.contactTelephone
                }}</el-descriptions-item>
                <el-descriptions-item label="电子邮箱">{{
                  article.contactEmail
                }}</el-descriptions-item>
                <el-descriptions-item label="联系地址">{{
                  article.contactAddress
                }}</el-descriptions-item>
              </el-descriptions>
              <p v-html="replaceBr(article.authorDesc)" style="
                  border: 1px solid #ebeef5;
                  padding: 5px;
                  font-size: 12px;
                  margin: 0;
                "></p>
              <p style="margin-bottom: 0">
                <img class="word" src="@/assets/word.png" /> {{ item.attachName }}
                <a @click="downArticle(item.fileId, item.attachName)" target="_blank" class="download">下载稿件原文</a>
              </p>
            </template>
          </template>

          <!--编辑评审-->
          <template v-else-if="item.processStep == 20 || item.processStep == 22 || item.processStep == 62">
            <template v-if="item.processStatus == 1">
              <template v-if="role == 'EDITOR'">
                <el-card>
                  <FormExamine :alterEnable="item.processStep == 20" :rejectEnable="item.processStep == 20" :role="role"
                    :articleId="articleId" :articleTitle="articleTitle" @examineSuccess="examineSuccess"
                    @examineReject="examineReject"></FormExamine>
                </el-card>
              </template>
              <template v-else><el-tag type="primary">等待评审</el-tag></template>
            </template>
            <template v-else-if="item.processStatus == 2">
              <el-tag type="success" v-if="item.processIdea == 2">通过</el-tag>
              <el-tag type="success" v-else-if="item.processIdea == 1">通过(需要改稿)</el-tag>
              <el-tag type="danger" v-else>不通过(退稿)</el-tag>
              <p style="margin-bottom: 0">
                <el-input type="textarea" :readonly="true" :rows="3" v-model="item.processRemark"
                  :autosize="{ minRows: 2, maxRows: 6 }">
                </el-input>
              </p>

              <p style="margin-bottom: 0" v-if="item.processIdea == 1 && item.fileId != null">
                <img class="word" src="@/assets/word.png" /> {{ item.attachName }}
                <a @click="downAuditAttach(item.fileId, item.attachName)" target="_blank" class="download">下载修改意见附件</a>
              </p>

            </template>
          </template>

          <!--支付版面费(专家不需要看到)-->
          <template v-else-if="item.processStep == 40 || item.processStep == 41">
            <template v-if="role != 'EXPERT'">
              <template v-if="item.processStatus == 1">
                <template v-if="role == 'USER'">
                  <el-card>
                    <FormPay :articleId="articleId" :type="2" :issueCost="article.issueCost" @paySuccess="paySuccess"
                      @payStatusChange="payStatusChange"></FormPay>
                  </el-card>
                </template>
                <template v-else>
                  <el-tag type="primary" v-if="item.processStep == 40">等待支付版面费</el-tag>
                </template>
              </template>
              <template v-else-if="item.processStatus == 2">
                <p>
                  <el-tag type="success" v-if="item.processIdea == 2">已付{{ article.issueCosted }}元</el-tag>
                </p>
              </template>
            </template>
          </template>

          <!--专家评审-->
          <template v-else-if="item.processStep == 50 || item.processStep == 52">
            <template v-if="item.processStatus == 1">
              <template v-if="role == 'EXPERT'">
                <el-card>
                  <FormExamine :alterEnable="item.processStep == 20 || item.processStep == 50"
                    :rejectEnable="item.processStep == 50" :role="role" :articleId="articleId"
                    :articleTitle="articleTitle" @examineSuccess="examineSuccess" @examineReject="examineReject">
                  </FormExamine>
                </el-card>
              </template>
              <template v-else><el-tag type="primary">等待评审</el-tag></template>
            </template>
            <template v-else-if="item.processStatus == 2">
              <el-tag type="success" v-if="item.processIdea == 2">通过</el-tag>
              <el-tag type="success" v-else-if="item.processIdea == 1">通过(需要改稿)</el-tag>
              <el-tag type="danger" v-else>不通过(退稿)</el-tag>
              <p style="margin-bottom: 0">
                <el-input type="textarea" :readonly="true" v-model="item.processRemark"
                  :autosize="{ minRows: 1, maxRows: 10 }">
                </el-input>
              </p>
              <p style="margin-bottom: 0" v-if="item.processIdea == 1 && item.fileId != null">
                <img class="word" src="@/assets/word.png" /> {{ item.attachName }}
                <a @click="downAuditAttach(item.fileId, item.attachName)" target="_blank" class="download">下载修改意见附件</a>
              </p>
            </template>

          </template>

          <!--上传修改的稿件-->
          <template v-else-if="item.processStep == 21 || item.processStep == 51 || item.processStep == 61">
            <template v-if="item.processStatus == 1">
              <template v-if="role == 'USER'">
                <el-card>
                  <FormArticleUpload :articleId="articleId" @articleUploadSuccess="articleUploadSuccess">
                  </FormArticleUpload>
                </el-card>
              </template>
              <template v-else><el-tag type="primary">等待改稿</el-tag></template>
            </template>
            <template v-else-if="item.processStatus == 2">
              <p>提交修改</p>
              <p style="margin-bottom: 0">
                <img class="word" src="@/assets/word.png" /> {{ item.attachName }}
                <a @click="downArticle(item.fileId, item.attachName)" target="_blank" class="download">下载稿件（修改）</a>
              </p>
            </template>
          </template>

          <!--上传著作权许可书-->
          
          <template v-else-if="item.processStep == 53 && role != 'EXPERT'">
              <template v-if="item.processStatus == 1">
                <FormLicenseUpload :articleId="articleId" @submitSuccess="licenseSubmitSuccess"></FormLicenseUpload>
              </template>
              <template v-else-if="item.processStatus == 2">
                <img class="word" src="@/assets/word.png" /> {{ item.attachName }}
                <a @click="downCopyright(item.fileId, item.attachName)" target="_blank" class="download">下载著作权许可书</a>
              </template>
          </template>

          <!--查重-->
          <template v-else-if="item.processStep == 60 || item.processStep == 63">
            <template v-if="item.processStatus == 1">
              <!--template v-if="role == 'EDITOR'">
                <el-card><FormDcrate :articleId="articleId" :type="item.processStep == 50 ? 1 : 2" @submitSuccess="dcrateSubmitSuccess"></FormDcrate></el-card>
              </template>
              <template-- v-else></template-->
              <el-tag type="primary">等待查重</el-tag>
            </template>
            <template v-else-if="item.processStatus == 2">
              <p>
                查重完毕
                <span class="dcRate" v-if="item.processStep == 60">{{ article.dcRate1 }}%</span>
                <span class="dcRate" v-else-if="item.processStep == 63">{{ article.dcRate2 }}%</span>

                <a v-show="item.processStep == 60 && article.dcFile1 >= 1"
                  @click="downDcFile(article.sn, article.title, article.dcFile1, 1)" target="_blank"
                  class="download">下载查重报告</a>
                <a v-show="item.processStep == 63 && article.dcFile2 >= 1"
                  @click="downDcFile(article.sn, article.title, article.dcFile2, 2)" target="_blank"
                  class="download">下载二次查重报告</a>
              </p>
            </template>
          </template>

          <!--版面费登记-->
          <template v-else-if="item.processStep == 30">
            <template v-if="item.processStatus == 1">
              <template v-if="role == 'EDITOR'">
                <el-card>
                  <FormBmf :articleId="articleId" @submitSuccess="bmfSubmitSuccess"></FormBmf>
                </el-card>
              </template>
              <template v-else><el-tag type="primary">等待编辑人员登记版面费</el-tag></template>
            </template>
            <template v-else-if="item.processStatus == 2">
              <p>
                已登记
                <el-tag size="mini" type="">{{ article.letterNoticePage }}</el-tag>页， 共<el-tag size="mini"
                  type="danger">{{ article.issueCost }}</el-tag>元，拟发表于<el-tag size="mini" type="warning">{{
                    article.letterNoticeTime
                  }}</el-tag>
                <template v-if="role == 'EDITOR' || article.status == 5">
                  <a @click="downNotice(articleId, article.sn, article.title)" target="_blank" class="download">下载用稿通知</a>
                </template>
              </p>
            </template>
          </template>

          <!--最终状态-->
          <template v-else-if="item.processStep == 99">
            <template v-if="article.status == 3">
              <p>{{ article.rejectRemark }}</p>
            </template>
            <template v-else-if="article.status == 4">
              <p>拟录用</p>
            </template>
            <template v-else-if="article.status == 5">
              <p>录用</p>
            </template>
            <template v-else> </template>
          </template>

        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
/**
 * 
10作者提交稿件，
20编辑审稿。   可以退稿
30编辑登记版面费。
40作者缴费。41线下付钱。
50专家审稿，51作者提交稿件，52专家再审稿  可以退稿，53作者上传同意书
60查重。61查重完毕，作者改稿中。62作者提高新稿，待查重。  可以退稿
70查重完毕，出录用通知。
99完成。
 */
import editorApi from "@/api/editor";
import authorApi from "@/api/author";
import expertApi from "@/api/expert";
import attachApi from "@/api/attach";
import FormExamine from "@/components/FormExamine.vue";
import FormPay from "@/components/FormPay.vue";
import FormArticleUpload from "@/components/FormArticleUpload.vue";
import FormLicenseUpload from "@/components/FormLicenseUpload.vue";
import FormBmf from "@/components/FormBmf.vue";
import attachUtil from "@/utils/attachUtil";

import dateUtil from "@/utils/dateUtil.js";

export default {
  name: "ArticleProcess",
  components: { FormExamine, FormPay, FormArticleUpload, FormLicenseUpload, FormBmf },
  props: {
    role: {
      type: String,
      require: true,
    },
    articleId: {
      type: Number,
      require: true,
    },
    action: {
      type: String,
      require: false,
    },
  },
  data() {
    return {
      article: {},
      processList: [],

      alter1: false,
      alter2: false,
      alter3: false,
      del1: false,
      configSteps: [
        { step: 10, title: "投稿" },
        { step: 20, title: "等待编辑审稿" },
        { step: 21, title: "等待作者改稿" },
        { step: 22, title: "等待编辑审稿" },
        { step: 30, title: "等待登记版面费" },
        { step: 35, title: "等待核对审稿费缴纳" },
        { step: 40, title: "等待支付版面费" },
        { step: 50, title: "等待专家审稿" },
        { step: 51, title: "等待作者改稿" },
        { step: 52, title: "等待专家审稿" },
        { step: 53, title: "等待上传著作权许可书" },
        { step: 60, title: "等待查重" },
        { step: 61, title: "等待作者改稿" },
        { step: 62, title: "等待编辑审稿" },
        { step: 63, title: "等待查重" },
        { step: 99, title: "完成" },
      ],
    };
  },
  mounted() {
    //this.configSteps = this.$config.steps;
    console.log(this.role);
    this.loadData();
  },
  methods: {
    replaceBr(str) {
      return str.replace(/[\n\r]/g, "<br/>");
    },
    loadData() {
      if (this.role == "USER") {
        authorApi.getArticleProcessList(this.articleId).then((res) => {
          if (res.code == 0) {
            this.processList = this.handleData(res.article, res.processList);
          }
        });
      } else if (this.role == "EDITOR") {
        editorApi.getArticleProcessList(this.articleId).then((res) => {
          if (res.code == 0) {
            this.processList = this.handleData(res.article, res.processList);
          }
        });
      } else if (this.role == "EXPERT") {
        expertApi.getArticleProcessList(this.articleId).then((res) => {
          if (res.code == 0) {
            this.processList = this.handleData(res.article, res.processList);
          }
        });
      }
    },

    handleData(orginArticle, orginProcessList) {
      this.article = orginArticle;
      this.articleTitle = orginArticle.title;

      let curStep = orginProcessList[orginProcessList.length - 1].processStep;
      let curStepStatus = orginProcessList[orginProcessList.length - 1].processStatus;
      let timeLineSteps = this.configSteps;
      let returnList = [];

      //判断是否改稿
      let gg1 = false;
      let gg2 = false;
      let checkPay = false;

      for (let i = 0; i < orginProcessList.length; i++) {
        if (orginProcessList[i].processStep == 51) {
          gg1 = true;
        } else if (orginProcessList[i].processStep == 61) {
          gg2 = true;
        } else if (orginProcessList[i].processStep == 70) {
          orginProcessList.splice(i, 1);
        }
      }

      //构造TimeLine
      for (let i = 0; i < this.configSteps.length; i++) {
        if (!checkPay) {
          for (let j = 0; j < timeLineSteps.length; j++) {
            if (timeLineSteps[j].step == 35) {
              timeLineSteps.splice(j, 1);
              break;
            }
          }
        }

        if (!gg1) {
          for (let j = 0; j < timeLineSteps.length; j++) {
            if (timeLineSteps[j].step == 51) {
              timeLineSteps.splice(j, 2);
              break;
            }
          }
        }

        if (!gg2) {
          for (let j = 0; j < timeLineSteps.length; j++) {
            if (timeLineSteps[j].step == 61) {
              timeLineSteps.splice(j, 3);
              break;
            }
          }
        }
      }

      //重新构造数据
      for (let i = 0; i < orginProcessList.length; i++) {
        for (let j = 0; j < timeLineSteps.length; j++) {
          if (timeLineSteps[j].step == orginProcessList[i].processStep) {
            orginProcessList[i].processTitle =
              timeLineSteps[j].title.replace("等待", "") +
              " " +
              dateUtil.fmt(orginProcessList[i].processRemarkTime, "YYYY-MM-DD HH:mm");
            break;
          }
        }
        returnList.push(orginProcessList[i]);
      }

      //console.log(curStep);
      for (let i = 0; i < timeLineSteps.length - 1; i++) {
        if (curStep < timeLineSteps[i].step) {
          returnList.push({
            processTitle: timeLineSteps[i].title.replace("等待", ""),
            processStatus: -1,
            processStep: timeLineSteps[i].step,
          });
        }
      }

      if (
        ((curStep == 60 || curStep == 62) && curStepStatus == 2) ||
        curStep == 70 ||
        curStep == 99 ||
        this.article.status == 3 ||
        this.article.status == 4 ||
        this.article.status == 5
      ) {
        returnList.push({
          processTitle: "结束",
          processStatus: 2,
          processStep: 99,
        });
      } else {
        returnList.push({
          processTitle: "结束",
          processStatus: -1,
          processStep: 99,
        });
      }

      //专家部分内容不可视
      if (this.role == "EXPERT") {
        for (let i = 0; i < returnList.length;) {
          if (
            returnList[i].processStep == 30 ||
            returnList[i].processStep == 40 ||
            returnList[i].processStep == 53 ||
            returnList[i].processStep >= 60
          ) {
            returnList.splice(i, 1);
          } else {
            i++;
          }
        }
      }
      return returnList;
    },

    setType(processStatus) {
      if (processStatus == 1) return "primary";
      else if (processStatus == 2) return "success";
      return "";
    },

    downAuditAttach(attachId, attachName) {
      attachApi.downAuditFile(attachId).then((res) => {
        if (res.type != "application/octet-stream") {
          this.$alert("下载失败，修改意见附件不存在!", "错误", {
            confirmButtonText: "确定",
          });
        } else {
          attachUtil.download(res, attachName);
        }
      });
    },

    downArticle(attachId, attachName) {
      attachApi.downArticle(attachId).then((res) => {
        if (res.type != "application/octet-stream") {
          this.$alert("下载失败，稿件附件不存在!", "错误", {
            confirmButtonText: "确定",
          });
        } else {
          attachUtil.download(res, attachName);
        }
      });
    },

    downNotice(articleId, sn, title) {
      attachApi.downNotice(articleId, sn, title).then((res) => {
        if (res.type != "application/octet-stream") {
          this.$alert("下载失败，用稿通知文件不存在!", "错误", {
            confirmButtonText: "确定",
          });
        } else {
          attachUtil.download(res, sn + "-" + title + "-用稿通知.pdf");
        }
      });
    },

    downDcFile(sn, title, attachId, type) {
      attachApi.downDcFile(attachId).then((res) => {
        if (res.type != "application/octet-stream") {
          this.$alert("下载失败，调查报告文件附件不存在!", "错误", {
            confirmButtonText: "确定",
          });
        } else {
          let attachName =
            sn + "-" + title + "-" + (type == 2 ? "2次" : "") + "查重报告.pdf";
          attachUtil.download(res, attachName);
        }
      });
    },

    downCopyright(attachId, attachName) {
      attachApi.downPersonCopyright(attachId).then((res) => {
        if (res.type != "application/octet-stream") {
          this.$alert("下载失败，个人著作权许可书不存在!", "错误", {
            confirmButtonText: "确定",
          });
        } else {
          attachUtil.download(res, attachName);
        }
      });
    },

    examineSuccess() {
      this.loadData();
      this.$emit("examineSuccess");
    },

    examineReject() {
      this.loadData();
      this.$emit("examineReject");
    },

    articleUploadSuccess() {
      this.loadData();
      this.$emit("processSuccess");
    },
    paySuccess() {
      this.loadData();
      this.$emit("processSuccess");
    },

    licenseSubmitSuccess() {
      this.loadData();
      this.$emit("processSuccess");
    },

    //支付状态发生改变
    payStatusChange() {
      this.loadData();
      this.$emit("paySuccess");
    },

    //版面费登记
    bmfSubmitSuccess() {
      this.loadData();
      this.$emit("bmfSubmitSuccess");
    },

    dcrateSubmitSuccess() {
      this.loadData();
      this.$emit("dcrateSubmitSuccess");
    },
  },
};
</script>

<style scoped>
.title {
  margin-bottom: 20px;
}

.articelInfo /deep/.el-descriptions__header {
  margin-top: 20px !important;
}

>>>.el-radio {
  margin-right: 0;
}

.pay_amount {
  font-size: 22px;
  color: #f56c6c;
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
}

.dcRate {
  font-size: 20px;
  color: #f56c6c;
  line-height: 1;
  vertical-align: middle;
}
</style>
